import { formatCircleDates } from "./formatCircleDates";

export function tryParseEvents(events = [], queryParams) {
  events = Array.isArray(events) ? events : [];
  try {
    events = formatCircleDates(events);
    events = filterByLanguage(events, queryParams);
    const [futureEvents, archivedEvents] = splitFutureAndPastEvents(events);

    return [futureEvents, archivedEvents];
  } catch (err) {
    console.error("Error parsing events", err);
    return [[], []];
  }
}

function splitFutureAndPastEvents(events) {
  const now = new Date();
  let futureEvents = events
    .filter((event) => event.endDateTime > now)
    ?.map((event) => ({
      ...event,
      isFutureEvent: true,
      canRegister: event.slots.find((slot) => slot.locationURL),
    }));
  futureEvents.sort((event1, event2) => (event1.startDateTime > event2.startDateTime ? 1 : -1));

  let archivedEvents = events.filter((event) => event.endDateTime <= now);
  archivedEvents = archivedEvents.filter((event) => event?.videoLink);

  return [futureEvents, archivedEvents];
}

// TODO - in browser language filtering to be replaced by japi/feed filtering when available
function filterByLanguage(events, queryParams) {
  if (queryParams.eventLanguage) {
    events = events.filter((event) =>
      event?.slots?.find((slot) => slot?.languages?.includes(queryParams.eventLanguage)),
    );
  }
  return events;
}
